import { api, normalizeImageRef } from "@/lib/lamka";

export const splitOptions = (s) => (s ? s.split(/[,/|]/).map((x) => x.trim()).filter(Boolean) : []);

export const startOrder = async (listingId, method, quantity) => {
  const { data: conv } = await api.post("/conversations", { listing_id: listingId });
  try {
    await api.post(`/conversations/${conv.id}/buy-intent`, { method, quantity });
  } catch {}
  return conv;
};

export const getContact = async (listingId) => {
  const { data } = await api.get(`/listings/${listingId}/contact`);
  return { upi: data.upi || data.seller_upi || data.vpa || null, phone: data.phone || null };
};

export const sendOrderNote = async (convId, { size, colour, address }) => {
  const parts = [size && `Size: ${size}`, colour && `Colour: ${colour}`, address && `Deliver to: ${address}`].filter(Boolean);
  if (!parts.length) return;
  try {
    await api.post(`/conversations/${convId}/messages`, { text: `Order details — ${parts.join(", ")}` });
  } catch {}
};

export const uploadImage = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload", form);
  const path = normalizeImageRef(typeof data === "string" ? data : data);
  if (!path) throw new Error("Upload failed");
  return path;
};

export const submitUpiProof = (listingId, convId, image, quantity) =>
  api.post("/payment-proofs", { listing_id: listingId, conversation_id: convId, image, quantity }).then((r) => r.data);

export const submitCod = (listingId, convId, quantity) =>
  api.post("/cash-requests", { listing_id: listingId, conversation_id: convId, quantity }).then((r) => r.data);

export const upiParams = ({ vpa, name, amount, note }) =>
  new URLSearchParams({ pa: vpa, pn: name || "Lamka Seller", am: Number(amount).toFixed(2), cu: "INR", tn: note }).toString();
